import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import TermsOfUse from '../views/TermsOfUse.vue'
import Privacy from '../views/Privacy.vue'
import Main from '../views/Main.vue'
import Logout from '../views/Logout.vue'
import Err from '../views/Error.vue'
import Create from '../views/Create.vue'
import Edit from '../views/Edit.vue'
import EditTree from '../views/EditTree.vue'
import CreateTree from '../views/CreateTree.vue'
import Play from '../views/PlayModes/Play'
import Learn from '../views/PlayModes/Learn'
import Record from '../views/PlayModes/Record'
import Hub from '../views/PlayModes/Hub'
import Watch from '../views/Watch'
import Recording from '../views/Recording'
import Account from '../views/Account'
import Admin from '../views/Admin'
import ResetPassword from '../views/ResetPassword'
import HomeNew from '../views/HomeNew.vue'

import axios from 'axios'
import alert from '../lib/alert'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home-old',
    name: 'Home',
    component: Home,
  },
  {
    path: '/',
    name: 'HomeNew',
    component: HomeNew,
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse,
  },
  {
    path: '/privacy-and-data-notice',
    name: 'Privacy',
    component: Privacy,
  },
  {
    path: '/main',
    name: 'Main',
    component: Main,
    meta: {requiresAuth: true}
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {requiresAuth: true}
  },
  {
    path: '/404',
    name: 'Error',
    component: Err
  },
  {
    path: '/create-old',
    name: 'Create',
    component: Create,
    meta: {requiresAuth: true}
  },
  {
    path: '/edit-old',
    name: 'Edit',
    component: Edit,
    meta: {requiresAuth: true}
  },
  {
    path: '/edit',
    name: 'EditTree',
    component: EditTree,
    meta: {requiresAuth: true}
  },
  {
    path: '/create',
    name: 'CreateTree',
    component: CreateTree,
    meta: {requiresAuth: true}
  },
  {
    path: '/play',
    name: 'Play',
    component: Play
  },
  {
    path: '/learn',
    name: 'Learn',
    component: Learn
  },
  {
    path: '/record',
    name: 'Record',
    component: Record
  },
  {
    path: '/hub',
    name: 'Hub',
    component: Hub
  },
  {
    path: '/watch',
    name: 'Watch',
    component: Watch,
    meta: {requiresAuth: true}
  },
  {
    path: '/recording',
    name: 'Recording',
    component: Recording
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {requiresAuth: true}
  },
  {
    path: '/resetPassword/:id',
    name: 'ResetPassword',
    component: ResetPassword,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const onlylogout = to.matched.some(record => record.meta.onlylogout);
  const token = localStorage.getItem('token');
  const validPaths = routes.map(route => {
    return route.name;
  })


  if(validPaths.includes(to.name)) {
    if(requiresAuth) {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}token`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(() => {
        next();
      }).catch(err => {
        if(err.message) {
          alert.showError(err.message);
        }
        if(err.response) {
          alert.showError(err.response.data.title);
        }
        localStorage.removeItem('token');
        next('/');
      })
    }else if(onlylogout && token) {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}token`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(() => {
        next('/main');
      }).catch(err => {
        if(err.message) {
          alert.showError(err.message);
        }
        if(err.response) {
          alert.showError(err.response.data.title);
        }
        next();
      })
    }else {
      next();
    }
  } else {
    if(token) {
      next('/main');
    } else {
      next('/');
    }
  }
})

export default router
